import { AdditionalText, LeadText } from '@ui-components/typography/Typography'
import { useIntl } from 'react-intl'
import { styled } from 'styled-components'

const LeftAlignedTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
`

export const DomesticAddressNeeded = () => {
  const { formatMessage } = useIntl()

  return (
    <LeftAlignedTextContainer>
      <LeadText tagName="p">
        {formatMessage({ id: 'sec-loans-catalog-tab-cannot-create-new-application-title' })}
      </LeadText>
      <AdditionalText tagName="p">
        {formatMessage({ id: 'sec-loans-catalog-tab-cannot-create-new-application-description' })}
      </AdditionalText>
    </LeftAlignedTextContainer>
  )
}
